import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import axios from "axios";
import { CiLock, CiUser } from "react-icons/ci";
import Footer from "../components/Footer";
import Header from "../components/Header";
import "./Login.css";
import Swal from "sweetalert2";
import authService from "../services/auth.service";

function Login() {
 
   


  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const login = async () => {




    if(navigator.onLine){
 try {
      if (!email || !password) {
        // alert("Please Enter Credentials");
        Swal.fire({
          title: "Please Enter Credentials!",
          icon: "question",
        });
        return;
      }

      const response = await authService.login(email, password);

      if (response.data.status === "success") {
        Swal.fire({
          title: "Welcome...",
          icon: "success",
          showConfirmButton: true,
          timer: 5000,
        });
        dispatch({ type: "SET_LOGIN" });
        localStorage.setItem("token", response.data.token || "aa");
        window.location.reload();
      } else {
        Swal.fire({
          title: `{${response.data.message}}`,
          icon: "error",
        });

        alert(response.data.message);
      }
    } catch (error) {
      Swal.fire({
        title: `Login Failed`,
        icon: "error",
      });
    }
    }

    else{
      alert("no Data")
    }
   
  };

  return (
    <>
      <Header />
      <div className="login-container">
        <div className="login-box">
          <a
            // href="https://uktechexam.co.in/UTU-Olympiad-2.pdf"
            className="notification-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            PHD. ENTRANCE EXAM
          </a>
          {/* <h4 className="login-title">UTU Olympiad 2.0</h4> */}
          <h3 className="login-subtitle">Login for Exam</h3>
          {/* <p className="login-text">Please Login to continue</p> */}
          <div className="login-form">
            <div className="input-group">
              <CiUser className="input-icon" />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
                className="login-input"
              />
            </div>
            <div className="input-group">
              <CiLock className="input-icon" />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                className="login-input"
              />
            </div>
            <button onClick={login} className="login-button">
              Login
            </button>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
}

export default Login;
